<template>
  <DpplTextField
    v-bind="{ ...$props, ...$attrs }"
  />
</template>
<script>
import DpplTextField from '@/components/datapeople/DpplTextField.vue';

export default {
  name: 'DpplSignupFormHalfTextField',
  components: { DpplTextField },
  props: {
    label: { type: String, default: '' },
    margin: { type: String, default: '0px' },
  },
};
</script>
<style scoped>
.text-field-container {
  text-align: left;
  margin: v-bind(margin);
}
:deep(.v-field) {
  width: 192px;
}
</style>
